import { SxProps, Theme } from "@mui/material";
import IconButton from "@mui/material/IconButton";

import APIcon, { APIconName } from "./APIcon";

const APIconButton = ({
  iconName,
  onClick,
  sx,
  isFaded,
  color = "onSurface",
  size,
}: {
  iconName: APIconName;
  onClick: () => void;
  sx?: SxProps<Theme>;
  isFaded?: boolean;
  color?: "onSurface" | "inherit";
  size?: "small" | "large" | "medium";
}) => {
  return (
    <IconButton
      size={size}
      color={color}
      onClick={() => onClick()}
      sx={{ ...sx, opacity: isFaded ? "40%" : "100%" }}
    >
      <APIcon name={iconName} size={size} />
    </IconButton>
  );
};

export default APIconButton;
